import { useQuery } from '@tanstack/react-query';
import { useMe } from '../auth/useMe';
import { fetchBilling } from './billing-api';

/** The API caches the balance for a minute; the shell asks no more often. */
const STALE_MS = 60_000;

/**
 * The balance the shell shows on every page (credit pill and banner, S150-1,
 * T140-1-5): one query, only for members who run AI jobs. Its own key, so the
 * billing page keeps its own loading and error states.
 */
export function useShellBilling() {
  const canUseAi = useMe().data?.active_tenant?.permissions.includes('ai:run') ?? false;
  const billing = useQuery({ queryKey: ['billing', 'shell'], queryFn: fetchBilling, enabled: canUseAi, retry: false, staleTime: STALE_MS });
  return { canUseAi, billing };
}
